module.exports = "<symbol id=\"tt-icon-social-facebook\" viewBox=\"0 0 24 24\"><path d=\"M13.84 23.86V13h3.63L18 8.82h-4.16V6.13c0-1.22.34-2.05 2.09-2.05h2.23V.31A29.87 29.87 0 0 0 14.9.14c-3.22 0-5.42 2-5.42 5.57v3.11H5.84V13h3.64v10.86z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/VuTUYdwvqIExdDFsite/assets/svg/search-page/social-facebook.svg
// module id = 434
// module chunks = 11